// extracted by mini-css-extract-plugin
export default {"button":"SubmissionCardButtons_button__1tbwl","buttons":"SubmissionCardButtons_buttons__XyepM"};